import * as React from "react";
import { FunctionComponent, useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Context } from "../../context/context";
import { AuthUserContext } from "../../context/AuthUserContext";
import { HelpIcon, LogoIcon } from "../Icons";
import AccountMenu from "./AccountMenu";
import SettingsMenu from "./SettingsMenu";

// The header of every page: logo and name, the page's actions (children), how to play, settings (the themes) and the
// account menu once the session has started. How to play opens the rules page, or calls `onHelp` (the game page
// shows the rules over the game instead).
const AppHeader: FunctionComponent<{ context: Context, onHelp?: () => void }> = ({ context, onHelp, children }) => {
    const { t } = useTranslation();
    const authUser = useContext(AuthUserContext);
    return (
        <header className="hdr">
            <Link className="logo" to="/" aria-label={`${t("Mancala")} · ${t("Home")}`}>
                <LogoIcon />
                <span>{t("Mancala")}</span>
            </Link>
            {children}
            <div className="hdr-tools">
                {onHelp
                    ? <button className="ibtn" aria-label={t("HowToPlay")} title={t("HowToPlay")} onClick={onHelp}><HelpIcon size={22} /></button>
                    : <Link className="ibtn" to="/rules" aria-label={t("HowToPlay")} title={t("HowToPlay")}><HelpIcon size={22} /></Link>}
                <SettingsMenu context={context} />
                {authUser && <AccountMenu context={context} authUser={authUser} />}
            </div>
        </header>
    );
};

export default AppHeader;
